<template>
  <section class="report-filters">
    <div class="report-filters__heading">
      <i class="pi pi-filter"></i>
      <div><strong>Filtros</strong><small>{{ scope === 'dates' ? 'Intervalo de datas' : 'Informação operacional' }}</small></div>
    </div>
    <div class="report-filters__fields">
      <span class="report-field">
        <label for="report-start-date">Data inicial</label>
        <Calendar id="report-start-date" v-model="local.startDate" dateFormat="dd/mm/yy" :showIcon="true" :maxDate="local.endDate" />
      </span>
      <span class="report-field">
        <label for="report-end-date">Data final</label>
        <Calendar id="report-end-date" v-model="local.endDate" dateFormat="dd/mm/yy" :showIcon="true" :minDate="local.startDate" />
      </span>
      <span v-if="scope === 'operations'" class="report-field">
        <label for="report-service-type">Tipo de serviço</label>
        <Dropdown inputId="report-service-type" v-model="local.serviceType" :options="options.serviceTypes" placeholder="Todos" :showClear="true" />
      </span>
      <span v-if="scope === 'operations'" class="report-field">
        <label for="report-status">Estado</label>
        <Dropdown inputId="report-status" v-model="local.status" :options="options.statuses" placeholder="Todos" :showClear="true" />
      </span>
      <span v-if="scope !== 'dates'" class="report-field">
        <label for="report-technician">Técnico</label>
        <Dropdown inputId="report-technician" v-model="local.technicianId" :options="options.technicians" optionLabel="name" optionValue="id" placeholder="Todos" :showClear="true" :filter="true" />
      </span>
      <span v-if="scope === 'operations'" class="report-field">
        <label for="report-brand">Marca</label>
        <Dropdown inputId="report-brand" v-model="local.brand" :options="options.brands" placeholder="Todas" :showClear="true" />
      </span>
      <span v-if="scope === 'operations'" class="report-field report-field--sla">
        <label for="report-sla">SLA (dias)</label>
        <InputNumber id="report-sla" v-model="local.slaDays" :min="1" :max="60" />
      </span>
    </div>
    <div class="report-filters__actions">
      <Button label="Limpar" icon="pi pi-times" class="p-button-outlined p-button-secondary" @click="$emit('reset')" />
      <Button label="Aplicar" icon="pi pi-check" :disabled="!valid" @click="apply" />
    </div>
  </section>
</template>

<script>
export default {
  name: "ReportFilterBar",
  props: {
    options: { type: Object, default: () => ({ statuses: [], serviceTypes: [], technicians: [], brands: [] }) },
    value: { type: Object, required: true },
    scope: { type: String, default: "operations" },
  },
  data() {
    return { local: this.parseFilters(this.value) };
  },
  computed: {
    valid() {
      return this.local.startDate instanceof Date && !isNaN(this.local.startDate.getTime())
        && this.local.endDate instanceof Date && !isNaN(this.local.endDate.getTime())
        && this.local.startDate <= this.local.endDate
        && (this.scope !== "operations" || (Number.isInteger(this.local.slaDays) && this.local.slaDays >= 1 && this.local.slaDays <= 60));
    },
  },
  watch: {
    value: { deep: true, handler(value) { this.local = this.parseFilters(value); } },
  },
  methods: {
    parseFilters(value) {
      const parse = (date) => {
        if (!date) return null;
        const [year, month, day] = date.split("-").map(Number);
        return new Date(year, month - 1, day);
      };
      return { ...value, startDate: parse(value.startDate), endDate: parse(value.endDate) };
    },
    formatDate(value) {
      if (!value) return null;
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, "0");
      const day = String(value.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    apply() {
      if (!this.valid) return;
      const filters = {
        ...this.value,
        startDate: this.formatDate(this.local.startDate),
        endDate: this.formatDate(this.local.endDate),
      };
      const fields = this.scope === "operations"
        ? ["serviceType", "status", "technicianId", "brand", "slaDays"]
        : this.scope === "parts" ? ["technicianId"] : [];
      fields.forEach((field) => { filters[field] = this.local[field]; });
      this.$emit("apply", filters);
    },
  },
};
</script>

<style scoped>
.report-filters { position: sticky; top: 4.5rem; z-index: 5; border: 1px solid #d9e4e5; border-radius: 13px; background: rgba(255,255,255,0.97); box-shadow: 0 7px 24px rgba(16,24,40,.08); padding: 1rem; display: flex; gap: 1rem; align-items: flex-end; }
.report-filters__heading { flex: 0 0 145px; display: flex; gap: .65rem; align-items: center; color: #0f6f78; }
.report-filters__heading > i { font-size: 1.35rem; }
.report-filters__heading div { display: flex; flex-direction: column; }
.report-filters__heading small { margin-top: .2rem; color: #667085; font-size: .69rem; }
.report-filters__fields { flex: 1; display: grid; grid-template-columns: repeat(7, minmax(105px, 1fr)); gap: .65rem; }
.report-field { display: flex; min-width: 0; flex-direction: column; gap: .3rem; }
.report-field label { color: #475467; font-size: .71rem; font-weight: 700; text-transform: uppercase; }
.report-field--sla { max-width: 100px; }
.report-field ::v-deep .p-dropdown, .report-field ::v-deep .p-calendar, .report-field ::v-deep .p-inputnumber { width: 100%; }
.report-filters__actions { display: flex; gap: .45rem; }
@media (max-width: 1300px) {
  .report-filters { position: static; align-items: stretch; flex-wrap: wrap; }
  .report-filters__heading { flex: 1 0 100%; }
  .report-filters__fields { grid-template-columns: repeat(4, minmax(135px, 1fr)); }
}
@media (max-width: 700px) {
  .report-filters__fields { grid-template-columns: 1fr 1fr; }
  .report-field--sla { max-width: none; }
  .report-filters__actions { width: 100%; justify-content: flex-end; }
}
</style>
